// extracted by mini-css-extract-plugin
export default {"heading":"Mt-z","corrected":"Nt-z","redirectVerbiageContainer":"Ot-z","redirectVerbiageText":"Pt-z"};